import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { schema } from '@techstyle/redux-core';
var slashRe = /^\/|\/$/g;
export var normalizePath = function normalizePath() {
  var path = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  if (!path) {
    return path;
  }

  var _path$split = path.split(/[?#]/),
      _path$split2 = _slicedToArray(_path$split, 1),
      pathname = _path$split2[0];

  return '/' + pathname.replace(slashRe, '');
};
export var Rewrite = new schema.Entity('Rewrite', {}, {
  idAttribute: function idAttribute(rewrite) {
    return normalizePath(rewrite.canonicalPath);
  },
  processStrategy: function processStrategy(rewrite) {
    return _objectSpread(_objectSpread({}, rewrite), {}, {
      canonicalPath: normalizePath(rewrite.canonicalPath)
    });
  }
});
export var RewriteMapping = new schema.Values(Rewrite);